<div class="jeopardy-final-scores-grid">
  <div class="final-scores-content">
    @if (!isNewHighScore) {
    <h2 class="jeopardy-full-span">{{ i18n.str('challengeu.final_scores_congratulations', "CONGRATULATIONS!")() }}</h2>
    }
    @if (isNewHighScore) {
    <h2 class="jeopardy-full-span">{{ i18n.str('challengeu.final_scores_high_score',"NEW HIGH SCORE!")() }} </h2>
    }

    <div class="score-summary">
      @if (isNewHighScore) {
      <div class="trophy-wrapper" style="margin-bottom: 3em;">
        <div class="rays"></div>
        <p class="trophy">
          <img src="assets/app-branding/img/trophy.png"
               [alt]="i18n.str('challengeu.final_scores_trophy', 'Trophy')()" />
        </p>
      </div>
      }
      <h3>
        {{ i18n.str('challengeu.final_scores_your_score',"Your score is:")() }}
        <br>
        {{ score }} {{ i18n.str('challengeu.question_points',"points")() }}
      </h3>
    </div>
    <br>
    <div class="final-score-actions">
      <div class="flip">
        <div class="flip-inner" [class.flipped]="showShareForm">
          <div class="flip-front buttons">
            <p class="jeopardy-button secondary">
              <a href="#" (click)="shareResults($event, true)">
                {{ i18n.str('challengeu.final_scores_share', "Share")() }}
              </a>
            </p>
            <br>
            <p class="jeopardy-button secondary">
              <a href="#" routerLink="/leaderboard"
                 title="{{ i18n.str('challengeu.final_scores_leaderboard', 'LEADERBOARD')() }}">
                {{ i18n.str('challengeu.final_scores_leaderboard', "LEADERBOARD")() }}
              </a>
            </p>
            <p class="jeopardy-button primary">
              <a href="#" routerLink="/main-menu" (click)="playAgain()"
                 title="{{ i18n.str('challengeu.final_scores_play_again', 'PLAY AGAIN')() }}">
                {{ i18n.str('challengeu.final_scores_play_again', "PLAY AGAIN")() }}
              </a>
            </p>
          </div>
          <div class="flip-back buttons">
            <h3>{{ i18n.str('challengeu.final_scores_share', "Share")() }}</h3>
            <div class="share-message-row">
              <div class="custom-message">{{shareMessage}}</div>
              <p class="jeopardy-button success">
                <a href="#" (click)="$event.preventDefault()" [cdkCopyToClipboard]="shareMessage">{{
                  i18n.str('challengeu.leaderboard_copy', "Copy")() }}</a>
              </p>
            </div>
            <div>
              <p class="jeopardy-button primary">
                <a href="#" (click)="copyMessage($event)" shareButton="facebook" url="{{host}}">{{
                  i18n.str('challengeu.leaderboard_share_facebook', "SHARE TO FACEBOOK")() }}</a>
              </p>
              <p class="jeopardy-button primary">
                <a href="#" (click)="$event.preventDefault()" shareButton="twitter" url="{{host}}">{{
                  i18n.str('challengeu.leaderboard_share_twitter', "SHARE TO TWITTER")() }}</a>
              </p>
              <p class="jeopardy-button secondary">
                <a href="#" (click)="shareResults($event, false)">{{ i18n.str('challengeu.btn_close', "Close")() }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
